import React from "react";
import { Add } from "@mui/icons-material";

import { HeaderButton } from "../../button/HeaderButton";
import { ButtonProps } from "@mui/material";

interface CreateButtonLibraryProps extends ButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
}

export function CreateButtonLibrary(props: CreateButtonLibraryProps) {
  const { children, onClick } = props;

  return (
    <HeaderButton
      startIcon={<Add />}
      onClick={onClick}
      children={children}
      {...props}
    />
  );
}
